<template>
<div>

  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>Confirm Trip Status<v-spacer/>
        <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title><v-divider/>
      <v-progress-linear :active="$apollo.queries.VehicleTrip.loading" :indeterminate="true"/>
      <v-card-text class="my-4">
        <h3>Trip ID: {{trip.tripId}}</h3>
        <div style="font-size: 18px;margin-top: 10px">Are you sure you want to change status of Trip ?</div>
      </v-card-text><v-divider/>
      <v-card-actions class="pa-3"><v-spacer/>
        <v-btn @click="closeDialog" class="mr-2 white elevation-0">CANCEL</v-btn>
        <v-btn @click="updateStatus" class="mr-2 primary elevation-0" :loading="loading">YES</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import moment from "moment";
import {IDS} from "../../Constants/IDS";
import {DISPATCH_PRE_ORDER_TRIP, DELIVER_PRE_ORDER_TRIP} from "../../graphql/mutations/PreOrderTrips";
import {GET_ORGANIZATION_STOCK_FOR_TRIP, GET_PRE_ORDER_TRIP_WITH_ORDERS} from "../../graphql/queries/PreOrderTrips";
import {generateUUID} from "../../Constants/Constants";
let Box = IDS.unitType.Box;
let Piece = IDS.unitType.Piece;
export default {
  name: "ChangeTripStatus",
  props: ['dialog', 'tripId', 'selectedStatusId'],
  apollo:{
    VehicleTrip: {
      query: GET_PRE_ORDER_TRIP_WITH_ORDERS,
      fetchPolicy: 'network-only',
      skip () {return !this.tripId || !this.dialog},
      variables(){ return{ id: this.tripId } },
      result ({data}) { this.afterFetchingTrip(data.VehicleTrip[0]) },
    },
  },
  data(){
    return{
      trip: {},
      loading: false,
      nextTripStatus: {
        [IDS.TripStatus.Completed]: IDS.TripStatus.Dispatched,
        [IDS.TripStatus.Dispatched]: IDS.TripStatus.Delivered
      },
      puObj: {}
    }
  },
  methods:{
    afterFetchingTrip(trip){
      this.trip = trip;
      let puObj = {};          //productId.unitId object
      trip.Order.forEach(o => {
        o.OrderItems.forEach(oi => {
          if(!puObj[oi.productId]) puObj[oi.productId] = {};
          puObj[oi.productId][oi.unitId] = oi.quantity + (puObj[oi.productId]?.[oi.unitId]||0)
          puObj[oi.productId]['noOfPieceInBox'] = oi.Product.noOfPieceInBox;
        })
      });
      Object.keys(puObj).forEach(id => {
        let {boxes, pieces} = this.evaluateBoxesPieces(puObj[id][IDS.unitType.Box], puObj[id][IDS.unitType.Piece], puObj[id]['noOfPieceInBox']);
        puObj[id][IDS.unitType.Box] = boxes;
        puObj[id][IDS.unitType.Piece] = pieces;
      })
      this.puObj = puObj;
    },
    async updateStatus(){
        this.loading = true;
        if(this.selectedStatusId === IDS.TripStatus.Dispatched) await this.dispatchTrip();
        else if(this.selectedStatusId === IDS.TripStatus.Delivered) await this.deliverTrip();
        this.loading = false;
        this.$emit('showToaster', { enable: true, color: 'green', message: 'Trip status updated successfully' });
        this.closeDialog();
    },
    async dispatchTrip(){
      await this.$apollo.mutate({
        mutation: DISPATCH_PRE_ORDER_TRIP,
        variables: {
          tripId: this.trip.id,
          tripObj: {statusId: IDS.TripStatus.Dispatched, dispatched_at: moment().format()},
          orderObj: {status: IDS.TripOrderStatus.Dispatched}
        }
      })
    },
    async deliverTrip(){
      let productIds = Object.keys(this.puObj);
      let response = await this.$apollo.query({
        query: GET_ORGANIZATION_STOCK_FOR_TRIP, fetchPolicy: 'network-only',
        variables: {id: this.trip.organizationId, productIds},
      });
      /* -- Insert missing product stock record (both box & piece records should exists) -- */
      let reverseUnit = {[Box]: Piece, [Piece]: Box};
      productIds.forEach(productId => {
        let pArr = response.data.OrganizationStock.filter(s => s.productId===productId);
        if(pArr.length===1){
          response.data.OrganizationStock.push({...pArr[0], id:generateUUID(), quantity:0, reservedQuantity:0, unitId:reverseUnit[pArr[0].unitId]})
        }
      });
      /* -------------x----------------x----------------x-----------x-----------x----------- */
      /* ----- Only when we need to open box ----------- */
      let pStockObj = {};             //org stock productId.unitId
      response.data.OrganizationStock.forEach(s => {
        if(!pStockObj[s.productId]) pStockObj[s.productId] = {};
        pStockObj[s.productId][s.unitId] = s.quantity;
      })
      response.data.OrganizationStock.forEach(s => {
        if(s.unitId===IDS.unitType.Piece && this.puObj[s.productId][Piece] > s.quantity && pStockObj[s.productId][IDS.unitType.Box]>0){
          pStockObj[s.productId][IDS.unitType.Box] = pStockObj[s.productId][IDS.unitType.Box] -1;
          pStockObj[s.productId][IDS.unitType.Piece] = s.quantity + this.puObj[s.productId]['noOfPieceInBox'];
        }
      })
      /* ----------x--------------x--------------x------- */
      // eslint-disable-next-line no-unused-vars
      let orgStock = response.data.OrganizationStock.map(({__typename, ...s}) => ({...s,
        quantity: pStockObj[s.productId][s.unitId] - this.puObj[s.productId][s.unitId],
        reservedQuantity: s.reservedQuantity - this.puObj[s.productId][s.unitId]
      }))
      // console.log('stock', orgStock);
      await this.$apollo.mutate({
        mutation: DELIVER_PRE_ORDER_TRIP,
        variables: {
          tripId: this.trip.id,
          tripObj: {statusId: IDS.TripStatus.Delivered, delivered_at: moment().format()},
          orderObj: {status: IDS.TripOrderStatus.Delivered},
          orgStock,
          updateColumnsOrgStock: ['quantity', 'reservedQuantity']
        }
      });
    },
    evaluateBoxesPieces(boxes = 0, pieces = 0, noOfPieceInBox){
      return {boxes: (boxes+Math.floor(pieces/noOfPieceInBox)), pieces:(pieces%noOfPieceInBox) }
    },
    closeDialog() {
      this.trip = {};
      this.$emit('update:dialog', false);
    }
  }
}
</script>

<style scoped>

</style>